import React, { FC } from 'react';
import { ConfirmModal } from '@namespace/common';
import { useI18n } from '@namespace/i18n';

type PreWagerConfirmModalProps = {
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  subtitle?: string;
};

const PreWagerConfirmModal: FC<PreWagerConfirmModalProps> = ({
  onClose,
  onConfirm,
  title = 'web.personaloffice.bonuses.notification.forbidwithdrawal',
  subtitle = 'web.personaloffice.bonuses.notification.forbidwithdrawal_info'
}) => {
  const { t } = useI18n();

  return (
    <ConfirmModal
      onConfirm={onConfirm}
      onClose={onClose}
      title={t(title)}
      subtitle={t(subtitle)}
      confirm={t('web.personaloffice.bonuses.button.forbidwithdrawal.confirm')}
      close={t('web.personaloffice.bonuses.button.forbidwithdrawal.close')}
    />
  );
};

export default PreWagerConfirmModal;
